import { useTranslation } from 'react-i18next'
import { useScrollReveal } from '@/hooks/use-scroll-reveal'
import Container from '@/components/ui/container'
import SectionHeader from '@/components/ui/section-header'
import logoWhite from '@/assets/images/logo-white.png'

export default function Platform() {
  const { t } = useTranslation()
  const { ref, visible } = useScrollReveal()

  const pillars = t('platform.pillars', { returnObjects: true }) as {
    title: string
    description: string
  }[]

  return (
    <section
      ref={ref}
      id="platform"
      className="py-16 md:py-24 lg:py-32 bg-surface relative overflow-hidden"
    >
      <div className="absolute top-1/2 -left-40 w-[500px] h-[500px] bg-primary/5 blur-[140px] rounded-full -translate-y-1/2" />

      <Container className="relative z-10">
        <div className="grid grid-cols-12 gap-8 lg:gap-12">
          <div
            className={`col-span-12 lg:col-span-5 transition-all duration-700 ease-out ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <SectionHeader
              label={t('platform.label')}
              heading={
                <span className="inline-flex items-center flex-wrap gap-x-3">
                  {t('platform.headingPrefix')}
                  <img
                    src={logoWhite}
                    alt="Bravic"
                    className="inline-block h-[0.9em] w-auto align-baseline"
                  />
                  {t('platform.headingSuffix')}
                </span>
              }
            />
            <p className="text-on-surface-variant text-base md:text-lg leading-relaxed mt-6 md:mt-8">
              {t('platform.lede')}
            </p>
            <p className="text-on-surface-variant text-base md:text-lg leading-relaxed mt-4">
              {t('platform.lede2')}
            </p>
            <p className="text-on-surface-variant text-base md:text-lg leading-relaxed mt-4">
              {t('platform.lede3')}
            </p>
          </div>

          <div className="col-span-12 lg:col-span-7 lg:pl-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-outline-variant/10 border border-outline-variant/10">
              {pillars.map((pillar, i) => (
                <div
                  key={i}
                  className={`bg-surface-container-low p-6 md:p-8 transition-all duration-500 ease-out hover:bg-surface-container ${
                    visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                  style={{ transitionDelay: visible ? `${300 + i * 120}ms` : '0ms' }}
                >
                  <div className="w-8 h-px bg-primary mb-5" />
                  <h4 className="font-display text-lg md:text-xl font-bold mb-3 tracking-tight text-on-surface">
                    {pillar.title}
                  </h4>
                  <p className="text-on-surface-variant text-sm leading-relaxed font-light">
                    {pillar.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
